const readMore = require('./read_more.js');
readMore('extras__link--hidden', 'extras__items--hidden');
